import Container from '@/components/Container/Container'
import { ExplicitHead } from '@/components/DefaultHead/DefaultHead'
import Mail from '@/components/Mail/Mail'
import Main from '@/components/Main/Main'
import SimpleHeader from '@/components/SimpleHeader/SimpleHeader'

const DESTINATION = 'apply@edhrec.com'

const Apply = () => (
  <Main>
    <Container small>
      <ExplicitHead
        description='Apply to write for EDHREC'
        keywords='EDHREC,apply,write,author,article,wordpress'
        title='Apply | EDHREC'
      />
      <SimpleHeader>Write for EDHREC</SimpleHeader>
      <Mail
        description={
          <>
            <p>
              EDHREC is always on the lookout for new perspectives to add to our talented roster of contributors. We do
              not publish ad hoc articles or deck techs at this time but we are interested in prospective authors who
              have an idea for a series of articles with a central theme.
            </p>
            <p>
              If you have an idea for a novel and innovative series, complete this form or email your pitch to{' '}
              <a href={`mailto:${DESTINATION}`} rel='noreferrer' target='_blank'>
                {DESTINATION}
              </a>
              . Good pitches will contextualize or incorporate EDHREC data. Excellent pitches will also be free from
              spelling and grammar mistakes.
            </p>
          </>
        }
        destination={DESTINATION}
      />
    </Container>
  </Main>
)

export default Apply
